import { Stack } from '@mui/material';
import { EpisodeDuration, PubDate } from './components';
import PodcastEpisodeCell, {
  PodcastEpisodeCellProps,
} from './PodcastEpisodeCell';
import * as S from './styles';

interface EnhancedPodcastEpisodeCellProps extends PodcastEpisodeCellProps {
  pubDateInMillis: number;
  durationMillis: number;
}

const EnhancedPodcastEpisodeCell: React.FC<EnhancedPodcastEpisodeCellProps> = ({
  thumbnailUrl,
  episodeTitle,
  pubDateInMillis,
  durationMillis,
}) => (
  <PodcastEpisodeCell thumbnailUrl={thumbnailUrl} episodeTitle={episodeTitle}>
    <Stack direction="row" spacing={1}>
      <PubDate pubDateInMillis={pubDateInMillis} />
      <S.Container>{' • '}</S.Container>
      <EpisodeDuration durationMillis={durationMillis} />
    </Stack>
  </PodcastEpisodeCell>
);

export default EnhancedPodcastEpisodeCell;
